export default "#### Pay $500 reservation\n\nReserve the car fee-free now. You can pay the remaining balance via bank transfer.\n";